import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";


function Table() {
  const [table, setTable] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // ✅ use navigate instead of window.location
    const token = localStorage.getItem("token");


  const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this Table?")) return;

  try {
    const { data } = await apiClient.delete(ADMIN.DELETE_TABLE(id));
    if (!data.success) throw new Error(data.message || "Delete failed");

    toast.success("Table deleted successfully");
    setTable(table.filter((c) => c._id !== id));
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Failed to delete table");
  }
};

const handleEdit = (tableData) => {
    // Option 1: Navigate with query param
    navigate(`/addtable?id=${tableData._id}`);

    // Option 2: open a modal pre-filled with paymentData
  };

  useEffect(() => {
    const fetchtable = async () => {
      try {
        const { data } = await apiClient.get(ADMIN.GET_TABLE);
        if (data.success) {
          setTable(data.items);
        }
      } catch (err) {
        console.error("Error fetching table:", err);
        toast.error(err.response?.data?.message || err.message || "Failed to fetch tables");
      } finally {
        setLoading(false);
      }
    };

    fetchtable();
  }, []);

  const handleGenerateQr = async (table) => {
  try {
    const qrData = {
      tableId: table._id,
      tableNo: table.Table_No,
      url: `http://dinemate.flicknlink.com/login?tableId=${table._id}`,
    };

    const { data } = await apiClient.post(ADMIN.GENERATE_QR, qrData);
    if (data.success && data.qrImage) {
      toast.success("QR Code generated successfully!");

      setTable((prev) =>
        prev.map((t) =>
          t._id === table._id ? { ...t, QR_Code: data.qrImage } : t
        )
      );

      const link = document.createElement("a");
      link.href = data.qrImage;
      link.download = `Table-${table.Table_No}-QR.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      toast.error("Failed to generate QR code");
    }
  } catch (err) {
    console.error("Error generating QR:", err);
    toast.error(err.response?.data?.message || "Error generating QR code");
  }
};



  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title"> Table List </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
              <li className="breadcrumb-item active" aria-current="page">Table List</li>
            </ol>
          </nav>
        </div>

        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-8">
                    <h4 className="card-title">Table Data</h4>
                    <p className="card-description"></p>
                  </div>
                  <div className="col-4" style={{ display: "flex",alignItems: "center",justifyContent: "center",gap: "15px",}} >
                    <a href="./addtable">
                      <button className="btn-primary">Add Table</button>
                    </a>
                    
                  </div>
                </div>

                <div className="table-responsive mt-3">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th> Serial No </th>
                        <th> Table No </th>
                        <th> Floor </th>
                        <th> Person </th>
                        <th> QR Code </th>
                        <th> Status </th>
                        <th> Actions </th>

                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">Loading...</td>
                        </tr>
                      ) : table.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">No tables found</td>
                        </tr>
                      ) : (
                        table.map((t, index) => (
                          <tr key={t._id}>
                            <td>{index + 1}</td>
                            <td>{t.Table_No}</td>
                            <td>{t.Floor}</td>
                            <td>{t.Person}</td>
                            <td>{t.QR_Code ? t.QR_Code.substring(0, 10) + "..." : "N/A"}</td>
                            <td>{t.Status}</td>
                            <td>
                              <button
                                className="btn btn-primary me-2"
                                onClick={() => handleEdit(t)}
                              >
                                Edit
                              </button>
                                <button
                                className="btn btn-danger"
                                onClick={() => handleDelete(t._id)}
                              >Delete</button>

                              
                              <button className="btn btn-primary" onClick={() => handleGenerateQr(t)}>
                                Generate Qr code
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Table;
